import React, { Component } from 'react';
import './Header.css';

export default class Header extends Component {
  render() {
    return (
      <header className="body_header">
        <h1>Password Generator</h1>
      </header>
    );
  }
}
